import type { ActivityCockpitSnapshot } from '@internal/spassu-code-contract';
import type { CockpitDeliveryView } from './cockpitViewModel';
import { safeHttpUrl } from './safeHttpUrl';
import { deliveryStatusLabel } from './semanticLabels';

/**
 * Delivery is shown only from what SCM reported (RN-COCK-04): a pull request
 * reference, or a terminal outcome. A pending delivery with nothing reported
 * yields `null`, so the section is not drawn — the phase alone never implies
 * a delivery.
 */
export function createCockpitDeliveryView(
  snapshot: ActivityCockpitSnapshot,
): CockpitDeliveryView | null {
  const delivery = snapshot.sections.delivery.value;
  if (!delivery) return null;
  const reference = delivery.pullRequestUrl;
  const terminal =
    delivery.status === 'delivered' ||
    delivery.status === 'closed-without-delivery' ||
    delivery.status === 'cancelled';
  if (!reference && !terminal) return null;
  return {
    status: delivery.status,
    statusLabel: deliveryStatusLabel(delivery.status),
    pullRequestUrl: reference ? safeHttpUrl(reference) : null,
    pullRequestReference: reference ?? null,
    commitCount: delivery.commitCount,
  };
}
